import { render } from "./MarginFooterComponent.vue?vue&type=template&id=5c179b55"
import script from "./MarginFooterComponent.vue?vue&type=script&lang=js"
export * from "./MarginFooterComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__